import Modal from "@/components/modal";
import modalBackLogo from "@assets/logo.jpg";
import { Dispatch, SetStateAction, useMemo, useState, useEffect } from "react";
import Confetti from "react-confetti";

type Props = {
  winningBet?: number;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  draw?: any;
  winners?: any;
};

export default function RouletteSinglePage({ isOpen, setIsOpen, draw, winners }: Props) {
  const [img, setImg] = useState("");
  const [spinningNumbers, setSpinningNumbers] = useState<string[]>([]);
  const [isSpinning, setIsSpinning] = useState<boolean>(false);
  const [confetti, setConfetti] = useState<boolean>(false);
  // const colors = ["text-[#ffb200]", "text-white"];

  const currentImg = useMemo(() => {
    setTimeout(() => setImg(draw?.product?.productPicture), 1000);
    return draw?.product?.productPicture;
  }, [draw?.product?.productPicture]);

  useEffect(() => {
    if (!isOpen || !winners || winners.length === 0) return;

    setIsSpinning(true);
    setConfetti(false);

    const initialSpinningNumbers = winners.map(() =>
      Math.floor(Math.random() * 1000000000)
        .toString()
        .padStart(9, "0"),
    );
    setSpinningNumbers(initialSpinningNumbers);

    const interval = setInterval(() => {
      setSpinningNumbers((prevNumbers) =>
        prevNumbers.map(() =>
          Math.floor(Math.random() * 1000000000)
            .toString()
            .padStart(9, "0"),
        ),
      );
    }, 100);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      setIsSpinning(false);
      setConfetti(true);
    }, 4000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [isOpen, winners]);

  return (
    <>
      {confetti && (
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          recycle={false}
          numberOfPieces={500}
          gravity={0.5}
          initialVelocityX={15}
          initialVelocityY={25}
          tweenDuration={3000}
        />
      )}

      <img
        src={draw?.product?.productPicture}
        className={`${currentImg !== img ? "anime" : ""} before aspect-square object-contain`}
      />

      <Modal
        size={winners && winners.length > 5 ? "sm" : "sm"}
        isOpen={isOpen}
        className="bg-white text-white bg-opacity-10 border-2 border-solid border-gray-50 border-opacity-5 rounded-xl backdrop-blur-md"
        onRequestClose={() => setIsOpen(false)}
      >
        <div className="grid place-items-center w-fit mx-auto">
          <img src={modalBackLogo} className="size-24 rounded-full" />
        </div>
        <div
          className="mt-6 text-center grid gap-6"
          style={{
            gridTemplateColumns:
              winners?.length < 3
                ? "1fr"
                : winners?.length < 6
                  ? "repeat(2, 1fr)"
                  : "repeat(3, 1fr)",
          }}
        >
          {winners?.map((winner: any, index: any) => (
            <div
              key={index}
              className={`token flex [&>*]:flex-1 ${index % 2 === 0 ? "column-white" : "column-orange"}`}
            >
              {isSpinning
                ? spinningNumbers[index]?.split("").map((s, i) => (
                    <span key={i} className="text-5xl">
                      {s}
                    </span>
                  ))
                : winner?.tokenId?.split("").map((s: any, i: any) => (
                    <span key={i} className="text-5xl">
                      {s}
                    </span>
                  ))}
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
}
